import { render, staticRenderFns } from "./SlackSettings.vue?vue&type=template&id=f52506d2"
import script from "./SlackSettings.vue?vue&type=script&lang=js"
export * from "./SlackSettings.vue?vue&type=script&lang=js"
import style0 from "./SlackSettings.vue?vue&type=style&index=0&id=f52506d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports